import React, { Component } from 'react'

class OptionName extends Component {

  constructor(props) {
    super(props)
    this.state = {}
    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
  }

  handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  }
  handleMouseEnter(event) {
    this.props.onFocus(this.props.option, event);
  }
  handleMouseMove(event) {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  }

  render() {
    return (
      <div
        className={this.props.className}
        title={this.props.option.label}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
      >
      <i className={this.props.option.content.icon} aria-hidden="true"></i>
      {this.props.children}
      </div>
    )
  }

}

export default OptionName;



/** WEBPACK FOOTER **
 ** ./src/components/pages/OptionName.js
 **/